import { observer } from 'mobx-react';
import * as React from 'react';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import getFeedbackConfig from '../config/FeedbackConfig';
import { FeedbackArea } from '../config/schema/FeedbackAreas';
import { isWorkloadSupported } from 'owa-workloads';
import selectFeedbackArea from '../actions/selectFeedbackArea';

let styles = require('./FeedbackForm.scss');

@observer
export default class FeedbackAreaDropdown extends React.Component<{}, {}> {
    componentDidMount() {
        const options = this.getFeedbackDropdownItems();

        // Bootstrap the initial selection in the store
        this.onDropdownChanged(options[0]);
    }

    render() {
        const options = this.getFeedbackDropdownItems();
        return (
            <Dropdown
                options={options}
                onRenderOption={this.onRenderOption}
                className={styles.areaDropdown}
                defaultSelectedKey={options[0].key}
                onChanged={this.onDropdownChanged}
            />
        );
    }

    private onDropdownChanged(option: IDropdownOption) {
        let { subject, emailAddresses } = option.data;
        selectFeedbackArea(subject, emailAddresses);
    }

    private onRenderOption(
        props: IDropdownOption,
        defaultRender: (props: IDropdownOption) => JSX.Element
    ): JSX.Element {
        return (
            <span className={props.data.isRootArea ? styles.rootArea : styles.subArea}>
                {defaultRender(props)}
            </span>
        );
    }

    private mapFeedbackAreaToDropdownOptions(feedbackArea: FeedbackArea): IDropdownOption[] {
        let options: IDropdownOption[] = [];

        let {
            displayName,
            baseEmailAddresses,
            subAreas,
            topLevelOnlyEmailAddresses,
        } = feedbackArea;
        let feedbackAreaName = displayName;

        // Add the option for the general area
        options.push({
            key: feedbackAreaName,
            text: feedbackAreaName,
            data: {
                subject: feedbackAreaName,
                emailAddresses: baseEmailAddresses.concat(topLevelOnlyEmailAddresses || []),
                isRootArea: true,
            },
        });

        // Create the sub-items
        if (subAreas) {
            subAreas
                .sort((a, b) => a.displayName.localeCompare(b.displayName))
                .forEach(subArea => {
                    if (
                        subArea.workloads !== undefined &&
                        !isWorkloadSupported(subArea.workloads)
                    ) {
                        return;
                    }

                    let displayText = subArea.displayName;
                    options.push({
                        key: displayText,
                        text: displayText,
                        data: {
                            subject: `${feedbackAreaName} - ${subArea.displayName}`,
                            emailAddresses: baseEmailAddresses.concat(
                                subArea.additionalEmailAddresses || []
                            ),
                            isRootArea: false,
                        },
                    });
                });
        }

        return options;
    }

    private getFeedbackDropdownItems() {
        let sortedFeedbackAreas = getFeedbackConfig()
            .filter(area => isWorkloadSupported(area.defaultWorkloads))
            .concat(
                getFeedbackConfig().filter(area => !isWorkloadSupported(area.defaultWorkloads))
            );

        return sortedFeedbackAreas
            .map(this.mapFeedbackAreaToDropdownOptions)
            .reduce((options, area) => options.concat(area), []);
    }
}
